<template>
  <header class="bg-gray-900 body-font text-white ">
    <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
      <a class="flex title-font font-medium items-center  mb-4 md:mb-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10 text-white p-2 bg-indigo-500 rounded-full" viewBox="0 0 24 24">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
        </svg>
        <span class="ml-3 text-xl">FooCases</span>
      </a>
      <nav class="md:ml-auto flex flex-wrap items-center text-base justify-center">
        <a href="#projects" class="mr-5 hover:text-gray-600">Projects</a>
        <a :href="links.github" target="_blank" class="mr-5 hover:text-gray-600">Github</a>
        <a :href="links.linkedin" target="_blank" class="mr-5 hover:text-gray-600">LinkedIn</a>
        <a :href="links.email" target="_blank" class="mr-5 hover:text-gray-600">Email</a>
      </nav>

    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      links: {
        email: "mailto:kennethreyesheredia@gmail.com",
        github: "https://github.com/ken-bem",
        linkedin: "https://www.linkedin.com/in/kenneth-reyes-ken-bem/"
      }
    }
  },
}
</script>

<style scoped>

</style>